class ProductCardSwiper extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector('.swiper');
    if (!container || this.swiper) return;

    const lineType = this.getAttribute('data-dots-type') === 'line';

    this.swiper = new Swiper(container, {
      slidesPerView: 1,
      speed: 400,
      grabCursor: true,
      watchOverflow: true,
      pagination: {
        el: this.querySelector('.product-card__dots'),
        type: lineType ? 'progressbar' : 'bullets',
        dynamicBullets: !lineType,
        dynamicMainBullets: 1,
        clickable: true,
      },
      navigation: {
        prevEl: this.querySelector('.product-card__arrow--prev'),
        nextEl: this.querySelector('.product-card__arrow--next'),
      },
    });

    const url = this.getAttribute('data-url');
    if (url) {
      this.swiper.on('click', (swiper, event) => {
        if (event.target.closest('.product-card__dots, .product-card__arrow')) return;
        window.location.href = url;
      });
    }
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('product-card-swiper')) {
  customElements.define('product-card-swiper', ProductCardSwiper);
}
